"use strict";
exports.__esModule = true;
exports.getFlagPath = exports.timelineData = void 0;
var dateutil_1 = require("./dateutil");
exports.timelineData = [
    {
        label: "Bachelor in Software Engineering",
        startDate: (0, dateutil_1.toTs)("2009-09-01"),
        endDate: (0, dateutil_1.toTs)("2012-09-01"),
        type: "EDUCATION",
        line: 0,
        description: "Bachelor's degree in Software Engineering. Mostly focused on software architecture, data structures and algorithms, discrete mathematics, and object-oriented language (Java).",
        place: "HE Léonard de VINCI, Brussels",
        country: "Belgium",
        fullTime: true,
        timePercentage: 100,
        selfEmployed: false
    },
    {
        label: "Internship",
        shortLabel: "Intern",
        startDate: (0, dateutil_1.toTs)("2012-02-01"),
        endDate: (0, dateutil_1.toTs)("2012-05-01"),
        type: "INTERNSHIP",
        line: 1,
        description: "For the last year of my BSC we had to do a 3 months internship, I managed to find a position in England. During the internship I was mostly working on a solution for Blackberry phones using J2ME.",
        place: "Mobile Worker Plus, Richmond",
        country: "UK",
        fullTime: true,
        timePercentage: 100,
        selfEmployed: false,
        hideDate: true
    },
    {
        label: "Software developer at Mobile Worker Plus",
        startDate: (0, dateutil_1.toTs)("2012-10-01"),
        endDate: (0, dateutil_1.toTs)("2016-08-30"),
        type: "IT_WORK",
        line: 0,
        description: "After completing an unpaid internship during my studies, they decided to hire me. I quickly became development lead for their back-end and front-end Mobile Worker solution. The technologies used were mostly Java Spring and Java Android.",
        place: "Mobile Worker Plus, Richmond",
        country: "UK",
        fullTime: true,
        timePercentage: 100,
        selfEmployed: false
    },
    {
        label: "C++ developer at Nobel Biocare",
        startDate: (0, dateutil_1.toTs)("2016-10-01"),
        endDate: (0, dateutil_1.toTs)("2018-09-30"),
        type: "IT_WORK",
        line: 0,
        description: "I worked as a C++ developer at Nobel Biocare for 2 years. I joined a team of 50 developers following the Scrum framework by the letter. We were working on 3D desktop software for dental visualization. The technologies used were C++ with Qt.",
        place: "Medicim/Nobel Biocare, Mechelen",
        country: "Belgium",
        fullTime: true,
        timePercentage: 100,
        selfEmployed: false
    },
    {
        label: "Teacher training",
        startDate: (0, dateutil_1.toTs)("2018-09-01"),
        endDate: (0, dateutil_1.toTs)("2019-06-30"),
        type: "EDUCATION",
        hideDate: true,
        line: 2,
        description: "I completed my teacher training at Jury Central, Brussels.",
        place: "Jury Central, Brussels",
        country: "Belgium",
        fullTime: false,
        timePercentage: 20,
        selfEmployed: false
    },
    {
        label: "CS Teacher",
        startDate: (0, dateutil_1.toTs)("2018-10-01"),
        endDate: (0, dateutil_1.toTs)("2019-06-30"),
        type: "SCHOOL",
        line: 0,
        description: "I taught computer science at Institut national de radioélectricité et cinématographie, Brussels. I gave one course on software programming in Python and another course about hardware architecture.",
        place: "Institut national de radioélectricité et cinématographie, Brussels",
        country: "Belgium",
        fullTime: false,
        timePercentage: 66,
        selfEmployed: false,
        hideDate: window.innerWidth < 500
    },
    {
        label: "Remote consultant for Mobile Worker Plus",
        startDate: (0, dateutil_1.toTs)("2019-01-01"),
        endDate: (0, dateutil_1.toTs)("2025-09-20"),
        hideDate: true,
        type: "IT_WORK",
        line: 1,
        description: "In 2019, I started working remotely for Mobile Worker Plus for about 10 to 20 hours per week. My duties include mostly maintaining and improving the Mobile Worker solution. The technologies used are React/Typescript for web front-end, Java/Spring for back-end and Java/Android for mobile.<br><br>Since January 2025, my contract has been updated to work a minimum of 3 full days per week on the Octopass solution (Spring back-end & Angular front-end).",
        place: "Mobile Worker Plus, [remote]",
        country: "UK",
        fullTime: false,
        timePercentage: 50,
        timePercentageText: "between 40 and 60%",
        selfEmployed: true
    },
    {
        label: "Coordinator at CodeNPlay",
        startDate: (0, dateutil_1.toTs)("2019-10-01"),
        endDate: (0, dateutil_1.toTs)("2021-08-25"),
        type: "SCHOOL",
        line: 0,
        description: "I worked as a coordinator at CodeNPlay, Brussels. My duties involved facilitating animations about robotics in primary schools, training and supervising new intructors and working on course content.",
        place: "CodeNPlay, Brussels",
        country: "Belgium",
        fullTime: false,
        timePercentage: 50,
        selfEmployed: false
    },
    {
        label: "Teacher at Saint André",
        startDate: (0, dateutil_1.toTs)("2021-09-01"),
        endDate: (0, dateutil_1.toTs)("2023-07-30"),
        type: "SCHOOL",
        line: 0,
        description: "I gave courses on programming to students aged 14 to 17. After one year I became class-referent which meant I was giving individualized academic support to about 25 students.",
        place: "Institut Saint-André Catholic Secondary School, Brussels.",
        country: "Belgium",
        fullTime: false,
        timePercentage: 60,
        selfEmployed: false
    },
    {
        label: "Teacher at Mon Avenir",
        startDate: (0, dateutil_1.toTs)("2023-09-01"),
        endDate: (0, dateutil_1.toTs)("2025-03-30"),
        type: "SCHOOL",
        line: 0,
        description: "I taught at the Conseil scolaire catholique MonAvenir at Saint-Jean Aurora School as \"enseignant de gestion\". This role involved teaching subjects that main teachers did not cover, such as physical education and health.<br><br>After a school year at Saint-Jean Aurora, I chose to work as a supply teacher within the same school board  for a few months. I then taught various subjects, including mathematics, French, English, and social studies.",
        place: "Conseil scolaire Mon Avenir, Ontario, Canada",
        country: "Canada",
        fullTime: false,
        timePercentage: 50,
        selfEmployed: false
    },
];
var getFlagPath = function (event) {
    if (event.flagFilename && event.flagFilename.length > 0) {
        return "images/".concat(event.flagFilename, ".gif");
    }
    if (event.country) {
        if (event.country.startsWith("[")) {
            return event.country;
        }
        else {
            return "images/".concat(event.country.toLowerCase(), ".gif");
        }
    }
    else {
        return "";
    }
};
exports.getFlagPath = getFlagPath;
